import {getOpenId} from "@/utils/wxOpenid"
import {getUserInfoApi} from "@/service/index.js";
import {useWechatShareEffect} from "@/utils/wxShare.js";
import customConfig from "/customConfig";
import store from "@/store";
let first=true
// 设置标题
if(window.location.href.includes('openid')){
    console.log('设置1',window.location.href.split('openid=').pop())
    localStorage.setItem(customConfig.openIdName, window.location.href.split('openid=').pop())
    store.commit('setOpenid', window.location.href.split('openid=').pop())
}
document.title = customConfig.title
console.log('配置文件', customConfig)

// 判断openid userInfo是否存在,存在赋值
let userInfo = localStorage[customConfig.userInfoName]
let openid = localStorage[customConfig.openIdName]
if (userInfo) {
    store.commit('setUserInfo', JSON.parse(userInfo))
}
if (openid) {
    store.commit('setOpenid', openid)
}
const cb = () => {
    store.commit('setOpenid', localStorage.getItem(customConfig.openIdName))
    getUserInfoApi({openid: store.state.openId}).then(res => {
        if (res.data.code == 1) {
            store.commit('setUserInfo', res.data.data.user)
            store.commit('setOpenid',res.data.data.user.openid)
            localStorage.setItem(customConfig.userInfoName, JSON.stringify(res.data.data.user))
            localStorage.setItem(customConfig.openIdName, res.data.data.user.openid)

            // ——————————————————
            store.commit('setProjectInfo',res.data.data)
            // ——————————————————

        }
        if(res.data.code==0){
            // alert(res.data.code)
            localStorage.removeItem(customConfig.userInfoName)
            localStorage.removeItem(customConfig.openIdName)
            getOpenId(cb)
            // window.location.href=customConfig.link+'?time='+new Date().valueOf()
        }
    })
}
if (customConfig.shareConfig.open) {
    useWechatShareEffect()
}
// 初次进入判断是否调取授权和分享
// 初次进入判断是否调取授权和分享
setTimeout(()=>{
    if(first&&customConfig.authConfig.open){
        first=false
        if(window.location.href.includes('openid')){
            console.log('设置2',window.location.href.split('openid=').pop())
            localStorage.setItem(customConfig.openIdName, window.location.href.split('openid=').pop())
            store.commit('setOpenid', window.location.href.split('openid=').pop())
            cb()
        }else {
            console.log('222')
            getOpenId(cb)
        }
    }
})

// router.afterEach((to, from) => {
//     if(first&&customConfig.authConfig.open&&to.meta.checkAuth == true){
//         if(window.location.href.includes('openid')){
//             console.log('设置2',window.location.href.split('openid=').pop())
//             localStorage.setItem(customConfig.openIdName, window.location.href.split('openid=').pop())
//             store.commit('setOpenid', window.location.href.split('openid=').pop())
//             cb()
//         }else {
//             console.log('222')
//             getOpenId(cb)
//         }
//     }
//     first=false
// })
